module.exports = __webpack_public_path__ + "img/pic_8.d9e1c713.jpg";